<template>
  <div class="calc-desenquadramento-mei-results">
    <h2>Calculadora desenquadramento MEI</h2>
    <p class="calc-desenquadramento-mei-results__subtitle">Ocorreu um erro tente novamente mais tarde</p>
  </div>
</template>
<script>


export default {


}

</script>
<style lang="scss" src="./ErrorResult.styles.scss" scoped></style>
